"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
const experts = [{
  name: "Elena Vostrova",
  role: "Staff Engineer @ Vercel",
  quote: "Performance isn't just a metric; it's the foundation of user trust. When we shave milliseconds off a load time, we're not just optimizing code—we're respecting the user's time and attention.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1555312/img/expert_elena_vostrova.png",
  link: "#"
}, {
  name: "David Chen",
  role: "Core Maintainer @ React",
  quote: "The future of the web lies in the delicate balance between interactivity and stability. We are moving towards a world where hydration is granular, and the main thread is sacred.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1555312/img/expert_david_chen.png",
  link: "#"
}, {
  name: "Sarah Jenkins",
  role: "Head of Performance @ Shopify",
  quote: "Ecommerce conversion rates are directly tied to First Contentful Paint. We've seen that a 0.1s improvement can lead to a 1% increase in revenue. Speed is currency.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1555312/img/expert_sarah_jenkins.png",
  link: "#"
}, {
  name: "Marcus Thorne",
  role: "Principal Architect @ Google Chrome",
  quote: "Core Web Vitals are evolving. Interaction to Next Paint (INP) is changing how we think about responsiveness. It's no longer enough to load fast; you must respond instantly.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1555312/img/expert_marcus_thorne.png",
  link: "#"
}];
export default function ExpertPerspectives() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="expert-perspectives" ref={ref} className={`dark bg-background text-foreground py-24 overflow-hidden transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 md:mb-16 border-b border-border pb-6">
          <h2 className="text-3xl md:text-4xl font-medium tracking-tight text-foreground">
            Expert Perspectives
          </h2>
          <p className="mt-2 text-muted-foreground max-w-2xl">
            Industry leaders share their insights on the future of web performance.
          </p>
        </div>

        <Carousel opts={{
        align: "start",
        loop: true
      }} className="w-full">
          <CarouselContent className="-ml-4">
            {experts.map((expert, i) => <CarouselItem key={i} data-index={i} className="pl-4 md:basis-full lg:basis-full">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center border border-border bg-card/50 p-6 md:p-12 rounded-sm">
                  {}
                  <div className="lg:col-span-5 relative aspect-[4/5] w-full overflow-hidden rounded-sm bg-muted">
                    <img src={expert.image} alt={expert.name} className="h-full w-full object-cover grayscale contrast-125 transition-transform duration-500 hover:scale-105 hover:grayscale-0" />
                  </div>

                  {}
                  <div className="lg:col-span-7 flex flex-col justify-center space-y-8">
                    <blockquote className="space-y-6">
                      <p className="text-2xl md:text-4xl/tight font-sans italic font-light text-foreground">
                        &ldquo;{expert.quote}&rdquo;
                      </p>
                    </blockquote>

                    <div className="space-y-6 border-t border-border pt-8">
                      <div className="space-y-1">
                        <h3 className="text-xl font-semibold tracking-tight text-foreground">
                          {expert.name}
                        </h3>
                        <p className="text-muted-foreground font-mono text-sm uppercase tracking-wider">
                          {expert.role}
                        </p>
                      </div>

                      <Button asChild variant="outline" className="group border-foreground/20 hover:border-foreground hover:bg-transparent text-foreground rounded-full px-6">
                        <Link to={expert.link}>
                          Read Interview
                          <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                        </Link>
                      </Button>
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="flex justify-end gap-4 mt-8 pr-2">
            <div className="relative static flex gap-2">
               {}
              <CarouselPrevious className="static translate-y-0 translate-x-0 border-border hover:bg-accent hover:text-accent-foreground rounded-full h-12 w-12" />
              <CarouselNext className="static translate-y-0 translate-x-0 border-border hover:bg-accent hover:text-accent-foreground rounded-full h-12 w-12" />
            </div>
          </div>
        </Carousel>
      </div>
    </section>;
}